import React from "react";
import { useTranslation } from "react-i18next";

const About = () => {
  const { t } = useTranslation();

  // HTML içeren metinler için
  const createMarkup = (htmlContent) => {
    return { __html: htmlContent };
  };

  return (
    <section className="container-page section">
      {/* Başlık */}
      <div className="page-head">
        <h1 className="page-title">{t("about.title")}</h1>
      </div>

      {/* Ana Paragraf */}
      <div className="max-w-3xl border-l-2 border-accent pl-6">
        <p
          className="text-[16px] leading-[1.75] text-body [&_strong]:font-semibold [&_strong]:text-ink"
          dangerouslySetInnerHTML={createMarkup(t("about.mainParagraph"))}
        />
      </div>

      {/* Grid Bölümü */}
      <div className="mt-14 grid gap-px overflow-hidden rounded-lg border border-line bg-line md:grid-cols-2">
        <div className="bg-white p-8">
          <div className="mb-4 flex h-9 w-9 items-center justify-center rounded-md bg-accent-soft">
            <svg
              className="h-5 w-5 text-accent"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
                d="M13 10V3L4 14h7v7l9-11h-7z"
              ></path>
            </svg>
          </div>
          <h3 className="text-[17px] font-semibold text-ink">
            {t("about.corporateDevelopment.title")}
          </h3>
          <p
            className="mt-3 text-[15px] leading-relaxed text-body"
            dangerouslySetInnerHTML={createMarkup(
              t("about.corporateDevelopment.description")
            )}
          />
        </div>

        <div className="bg-white p-8">
          <div className="mb-4 flex h-9 w-9 items-center justify-center rounded-md bg-accent-soft">
            <svg
              className="h-5 w-5 text-accent"
              fill="none"
              stroke="currentColor"
              viewBox="0 0 24 24"
            >
              <path
                strokeLinecap="round"
                strokeLinejoin="round"
                strokeWidth="1.8"
                d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z"
              ></path>
            </svg>
          </div>
          <h3 className="text-[17px] font-semibold text-ink">
            {t("about.futureVision.title")}
          </h3>
          <p
            className="mt-3 text-[15px] leading-relaxed text-body"
            dangerouslySetInnerHTML={createMarkup(
              t("about.futureVision.description")
            )}
          />
        </div>
      </div>

      {/* Alıntı Bölümü */}
      <figure className="mt-14 rounded-lg bg-ink px-8 py-12 text-center sm:px-14">
        <blockquote className="mx-auto max-w-3xl text-[19px] font-medium leading-relaxed text-white sm:text-[22px]">
          {t("about.quote.text")}
        </blockquote>
        <figcaption className="mt-6 text-[13px] font-medium uppercase tracking-eyebrow text-white/50">
          {t("about.quote.author")}
        </figcaption>
      </figure>
    </section>
  );
};

export default About;
